// SdsApi.js
// 3E Protect SDS lookup client (search, detail, PDF proxy URL, Request SDS).
import axios from "axios";
import { setupCsrfInterceptor } from "../auth/csrfUtils";

// v4 has no shared apiClient: same per-module instance as the other API files
const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

setupCsrfInterceptor(api);

const baseUrl = "/sds";
// 3E can be slow; fail fast enough that Retry is usable on an iPad in the field
const SDS_TIMEOUT_MS = 20000;

// The blueprint returns the standard { success, data } envelope
const payload = (response) => response?.data?.data;

export const getSdsStatus = async () => payload(await api.get(`${baseUrl}/status`));

export const searchSds = async (criteria, page = 1, pageSize = 25) =>
  payload(
    await api.post(
      `${baseUrl}/search`,
      { ...criteria, page, page_size: pageSize },
      { timeout: SDS_TIMEOUT_MS }
    )
  );

export const getSdsItem = async (productUid) =>
  payload(
    await api.get(`${baseUrl}/item/${encodeURIComponent(productUid)}`, {
      timeout: SDS_TIMEOUT_MS,
    })
  )?.detail;

// Plain same-origin anchor target: cookie auth, GET, no CSRF, no blob held in iPad memory
export const buildSdsDownloadUrl = ({
  document_link,
  product_name,
  manufacturer_name,
  revision_date,
} = {}) =>
  `/api/sds/document?${new URLSearchParams({
    url: document_link || "",
    product_name: product_name || "",
    manufacturer_name: manufacturer_name || "",
    revision_date: revision_date || "",
  })}`;

export const createSdsRequest = async (body) =>
  payload(await api.post(`${baseUrl}/requests`, body, { timeout: SDS_TIMEOUT_MS }));

export const getSdsRequests = async ({ status = "all", page = 1, pageSize = 50 } = {}) =>
  payload(
    await api.get(
      `${baseUrl}/requests?${new URLSearchParams({
        status,
        page: String(page),
        page_size: String(pageSize),
      })}`
    )
  );

export const sdsErrorMessage = (err) =>
  err?.response?.data?.error ||
  (err?.code === "ECONNABORTED"
    ? "3E is slow to respond. Try again."
    : "SDS lookup failed. Check your connection and try again.");

export const sdsRetryAfter = (err) =>
  Number(err?.response?.headers?.["retry-after"]) || null;
